export function roundTo(input: number, digits: number): number {
  const rounder = Math.pow(10, digits);

  return parseFloat((Math.round(input * rounder) / rounder).toFixed(digits));
}
export function getRandomInt(min: number, max: number): number {
  min = Math.ceil(min);
  max = Math.floor(max);

  return Math.floor(Math.random() * (max - min + 1)) + min;
}
